import Anchor from '@/components/base/anchor'
import Icon from '@/components/base/icon'
import useAuthStore from '@/context/useAuth'
import { IAuthUrl } from '@/utils/types'
import { useApp } from '@wap-client/core'
import { useRouter } from 'next/router'
import React from 'react'
import { useAuth } from 'react-oidc-context'

const LoginRegister = () => {
  const app = useApp()
  const auth = useAuth()
  const router = useRouter()
  const { authData } = useAuthStore()
  const profilePage = app.settings.routes?.['my-profile']?.href || 'my-profile'

  if (auth?.isLoading) {
    return null
  }

  return (
    <div className="header-login-register">
      {authData?.isAuth && authData?.user ? (
        <div className="login-profile-wrapper">
          {/* <p>
            {authData?.user?.given_name + ' ' + authData?.user?.family_name}
          </p> */}
          <Anchor
            type="button"
            className="login-profile-btn"
            href={`${profilePage}`}
          >
            {authData?.user?.given_name?.slice(0, 2).toUpperCase()}
          </Anchor>
        </div>
      ) : (
        <button
          className="login-sign-icon"
          onClick={() => {
            router.push(`auth/${IAuthUrl.REDIRECT}`)
          }}
        >
          <Icon name="user-circle" />
        </button>
      )}
    </div>
  )
}

export default LoginRegister
